import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiUsers, FiAward, FiShield, FiClock } = FiIcons;

const About = () => {
  return (
    <section id="about" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl font-bold text-gray-900 mb-4">About Apex Aerials</h2>
          <div className="w-24 h-1 bg-red-600 mx-auto"></div>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <h3 className="text-2xl font-bold text-gray-900 mb-6">
              Family-Run Business Since 1963
            </h3>
            <p className="text-gray-600 text-lg leading-relaxed mb-6">
              Here at Apex Aerials we are a small family run business that has been helping the public and major businesses for over 60 years for all their aerial and satellite needs. With thousands of satisfied customers and one of the highest rated satellite and aerial companies on Checkatrade, we are sure you will be happy with any work carried out by ourselves.
            </p>

            <div className="grid sm:grid-cols-2 gap-6">
              <div className="flex items-start gap-3">
                <SafeIcon icon={FiUsers} className="w-6 h-6 text-red-600 mt-1" />
                <div>
                  <h4 className="font-semibold text-gray-900">Thousands of</h4>
                  <p className="text-gray-600">Satisfied Customers</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <SafeIcon icon={FiAward} className="w-6 h-6 text-red-600 mt-1" />
                <div>
                  <h4 className="font-semibold text-gray-900">60+ Years</h4>
                  <p className="text-gray-600">Experience</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <SafeIcon icon={FiShield} className="w-6 h-6 text-red-600 mt-1" />
                <div>
                  <h4 className="font-semibold text-gray-900">Fully Insured</h4>
                  <p className="text-gray-600">Complete Protection</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <SafeIcon icon={FiClock} className="w-6 h-6 text-red-600 mt-1" />
                <div>
                  <h4 className="font-semibold text-gray-900">2 Year</h4>
                  <p className="text-gray-600">Guarantee</p>
                </div>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="bg-white p-8 rounded-lg shadow-lg"
          >
            <h3 className="text-2xl font-bold text-gray-900 mb-6">Why Choose Us?</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <div className="w-2 h-2 bg-red-600 rounded-full mt-2"></div>
                <span className="text-gray-600">Over 1000 reviews on Checkatrade</span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-2 h-2 bg-red-600 rounded-full mt-2"></div>
                <span className="text-gray-600">Over 40 reviews on Trustatrader</span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-2 h-2 bg-red-600 rounded-full mt-2"></div>
                <span className="text-gray-600">Free call outs and quotes</span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-2 h-2 bg-red-600 rounded-full mt-2"></div>
                <span className="text-gray-600">Same day service available</span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-2 h-2 bg-red-600 rounded-full mt-2"></div>
                <span className="text-gray-600">No cowboys at our ranch</span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-2 h-2 bg-red-600 rounded-full mt-2"></div>
                <span className="text-gray-600">All old equipment removed and taken away</span>
              </li>
            </ul>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;